import { useEffect, useState } from 'react';

const useIsConsentGranted = () => {
  const [isConsentGranted, setConsentGranted] = useState(false);

  // useEffect so this only runs client-side. Otherwise the build phase will complain about window being undefined.
  useEffect(() => {
    setConsentGranted(Boolean(window.Osano?.cm?.analytics));
  }, []);

  return isConsentGranted;
};

export default useIsConsentGranted;
